module.exports = __webpack_public_path__ + "static/media/InfofromSeller.6a164422.png";